/* eslint-disable max-len */
/* eslint-disable react-hooks/exhaustive-deps */
import { Box, FormHelperText, Typography } from '@mui/material';
import { CicaafAPI } from 'api/cicaaf/cicaaf.api';
import { Header } from 'components/home';
import BottomActionButtons from 'components/shared/bottom_action_buttons';
import { ContainerForm } from 'components/shared/container_form';
import InputBooleanFormik from 'components/shared/custom_input_boolean_formik';
import InputLabelFormik from 'components/shared/custom_input_label_formik';
import InputSelectFormik from 'components/shared/custom_input_select_formik';
import { TopNavBar } from 'components/top_nav_bar';
import { MenuProvider } from 'contexts/menu/menu_context';
import { useFormik } from 'formik';
import { ECicaafSituacaoCadastral, ECicaafTipoEntidade, ELocalizacaoUnidade, ICicaafGeneralData } from 'interfaces/cicaaf.interface';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from 'routes/constants';
import { dadosGeraisValidationSchema } from './dadosGerais.validation';

const initialValues: ICicaafGeneralData = {
  cicaaf_uuid: '',
  entity_type: ECicaafTipoEntidade.COOPERATIVE,
  identification: '',
  entity_name: '',
  isCpf: true,
  city: 'Cuiabá',
  has_active_caf: null,
  cnpj_status: null,
  location_type: null,
  belongs_to_association_cooperative: null,
  parent_association_cooperative_uuid: null,
}

export const DadosGeraisCicaaf: React.FC = () => {
  const { uuid } = useParams();
  const navigate = useNavigate();
  const [associations, setAssociations] = useState<any[]>([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: dadosGeraisValidationSchema,
    validateOnChange: isSubmitting,
    validateOnBlur: isSubmitting,
    // highlight-start
    onSubmit: async (values) => {
      try {
        console.log('onSubmit called', values);
        const data = {
          ...values,
          cicaaf_uuid: uuid,
        }
        await CicaafAPI.updateBasicInfo(uuid as string, data);

        navigate(
          ROUTES.PRODUCAO_COMERCIALIZACAO_CICAAF.replace(
            ':uuid',
            uuid as string,
          ),
        );
      } catch (error) {
        console.error("Failed to update data:", error);
      }
    },
  });

  const handleGetDataByID = async () => {
    const data = await CicaafAPI.getDataByID(uuid as string);
    const { dados } = data as any;
    console.log(dados);
    const rawIdentification = dados.identification?.replace(/\D/g, '') || '';
    const isCpf = rawIdentification.length === 11;

    formik.setValues({
      ...initialValues,
      cicaaf_uuid: dados.uuid,
      entity_type: dados.entity_type,
      city: dados.institution.address.municipality,
      identification: dados.identification,
      entity_name: dados.entity_name,
      isCpf: isCpf,
      has_active_caf: dados.has_active_caf,
      cnpj_status: dados.cnpj_status,
      location_type: dados.location_type,
      belongs_to_association_cooperative: dados.belongs_to_association_cooperative,
      parent_association_cooperative_uuid: dados.parent_association_cooperative_uuid,
    })
  }

  const handleGetAssociations = async () => {
    const data = await CicaafAPI.getAssociations();
    const { dados } = data as any;
    console.log("associations", dados);
    setAssociations(dados);
  }

  const handleSend = async () => {
    setIsSubmitting(true);
    console.log('handleSend invoked');
    if (process.env.NODE_ENV === 'test') {
      try {
        const data = {
          ...formik.values,
          cicaaf_uuid: uuid,
        }
        await CicaafAPI.updateBasicInfo(uuid as string, data);
        navigate(
          ROUTES.PRODUCAO_COMERCIALIZACAO_CICAAF.replace(':uuid', uuid as string),
        );
      } catch (error) {
        console.error('Failed to update data:', error);
      }
      return;
    }

    formik.handleSubmit();
  }

  useEffect(() => {
    if (uuid) {
      handleGetDataByID();
      handleGetAssociations();
    }
  }, [uuid]);

  return (
    <MenuProvider>
      <TopNavBar />
      <Header title={`CICAAF - Dados Gerais`} showBackButton={true} />
      <Box width='97%' display='flex' flexDirection='column' justifyContent='center' alignItems='center' margin='2rem'>

        <ContainerForm title='Informações Gerais' subtitle='Informe corretamente os dados gerais do CICAAF.' width='1152px'>


          <Box marginBottom='1rem'>
            <InputLabelFormik
              formik={formik}
              label='entity_type'
              labelTexto='Tipo de Entidade'
              required={true}
              disabled={true}
              version='primary'
            />
          </Box>

          <Box marginBottom='1rem'>
            <InputLabelFormik
              formik={formik}
              label='identification'
              labelTexto={formik.values.isCpf ? 'CPF' : 'CNPJ'}
              mask={formik.values.isCpf ? 'cpf' : 'cnpj'}
              maxLength={formik.values.isCpf ? 11 : 14}
              required={true}
              disabled={true}
              placeholder={formik.values.isCpf ? '000.000.000-00' : '00.000.000/0000-00'}
              version='primary'
            />
          </Box>

          <Box marginBottom='1rem'>
            <InputLabelFormik
              formik={formik}
              label='entity_name'
              labelTexto={formik.values.isCpf ? 'Nome' : 'Razão Social'}
              required={true}
              version='primary'
              disabled={true}
            />
          </Box>

          <Box marginBottom='1rem'>
            <InputLabelFormik
              formik={formik}
              label='city'
              labelTexto='Cidade'
              required={true}
              version='primary'
              disabled={true}
            />
          </Box>
          <Box marginBottom='1rem'>
            <InputBooleanFormik
              formik={formik}
              label='has_active_caf'
              labelTexto='Possui Cadastro Nacional da Agricultura Familiar (CAF)?'
            />
          </Box>




          {
            !formik.values.isCpf ?
              <>

                <Box marginBottom='1rem'>
                  <InputSelectFormik
                    formik={formik}
                    label='cnpj_status'
                    labelTexto='Situação Cadastral do CNPJ'
                    required={true}
                    placeholder='Selecione a situação cadastral'
                    options={[
                      { value: ECicaafSituacaoCadastral.ACTIVE, label: 'Ativa' },
                      { value: ECicaafSituacaoCadastral.SUSPENDED, label: 'Suspensa' },
                      { value: ECicaafSituacaoCadastral.UNFIT, label: 'Inapta' },
                      { value: ECicaafSituacaoCadastral.ACTIVE_NOT_REGULAR, label: 'Ativa Não Regular' },
                      { value: ECicaafSituacaoCadastral.CLOSED, label: 'Baixada' },
                      { value: ECicaafSituacaoCadastral.NULL, label: 'Nula' },
                    ]}
                  />
                </Box>
              </>
              :
              null
          }

          <Box marginBottom='1rem'>
            <InputSelectFormik
              formik={formik}
              label='location_type'
              labelTexto='Localização da Unidade'
              required={true}
              placeholder='Selecione a localização da unidade'
              options={[
                { value: ELocalizacaoUnidade.RURAL_ZONE, label: 'Zona Rural' },
                { value: ELocalizacaoUnidade.URBAN_ZONE, label: 'Zona Urbana' },
              ]}
            />
          </Box>

          {
            formik.values.entity_type === ECicaafTipoEntidade.AGROINDUSTRY ?
              <>
                <Box marginBottom='1rem'>
                  <InputBooleanFormik
                    formik={formik}
                    label='belongs_to_association_cooperative'
                    labelTexto='É parte de uma associação ou cooperativa?'
                  />
                </Box>

                {
                  formik.values.belongs_to_association_cooperative && (
                    <Box marginBottom='1rem'>
                      <InputSelectFormik
                        formik={formik}
                        label='parent_association_cooperative_uuid'
                        labelTexto='Associação ou Cooperativa'
                        required={true}
                        placeholder='Selecione a associação ou cooperativa'
                        options={[
                          ...(associations.length > 0 ? associations.map((association) => ({
                            value: association.uuid,
                            label: `${association.entity_name} (${association.entity_type})`,
                            disabled: false
                          })) : [{
                            value: null,
                            label: 'Não há associações ou cooperativas cadastradas',
                            disabled: true
                          }])
                        ]}
                      />
                      <FormHelperText error style={{
                        display: associations.length === 0 ? 'block' : 'none'
                      }}>
                        <Typography variant='body2' color='red'>
                          Primeiro cadastre uma associação ou cooperativa, e somente após isso você poderá prosseguir com esse cadastro.
                        </Typography>
                      </FormHelperText>
                    </Box>
                  )
                }
              </>
              :
              null
          }

          <BottomActionButtons
            handleEnviarAprovacao={handleSend}
            enviarAprovacaoTexto='Avançar'
            isFormValid={formik.isValid}
            handleCancelar={() => navigate(-1)}
            cancelarTexto='Voltar'
          />

        </ContainerForm>



      </Box>
    </MenuProvider>
  )
}
